export const globalOnSetFilters = <T>(
  setFilters: React.Dispatch<React.SetStateAction<T>>,
  key: keyof T,
  value: T[keyof T] | any
) => {
  setFilters((prev: T) => {
    let object = { ...prev };

    if (value === "") {
      // @ts-ignore
      delete object[key];
    } else {
      object[key] = value;
    }
    return { ...object };
  });
};

// Example usage
// onSetFilters<IBodyTypeParams>(setFiltersFunction, "filterKey", "filterValue");
